var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscoMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 220.61 261.98"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M102.35 0 37.02 87.33h46.86l-65.32 87.32h46.76L0 261.98h118.3l65.29-87.33h-46.75l65.31-87.32h-46.84L220.61 0z"
})));
export default SvgDiscoMark;